export default __webpack_public_path__ + "static/media/08.4208cd22.png";